/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectInstance} from "../../../models/object-instance";
import {Breadcrumb} from "./person-ui";
import {Point} from "../../../models/point";

export class ObjectUi {
  mObject: ObjectInstance;
  breadcrumbs: Breadcrumb[] = [];
  mIcon: createjs.Bitmap;
  mLastPosition: Point;
}
